import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Loader } from 'shared/components';

import theme from './LoadingMessage.scss';

const propTypes = {
  loadingMessage: PropTypes.object.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  mediaResized: PropTypes.bool,
};

const defaultProps = {
  size: 'small',
  mediaResized: false,
};

const LoadingMessage = ({ loadingMessage, size, mediaResized }) => (
  <div
    className={ classnames(theme.preloaderContainer, {
      [theme[size]]: size,
      [theme.mediaResized]: mediaResized,
    }) }
  >
    <FormattedMessage { ...loadingMessage } />
    <Loader color="#bbbbbb" />
  </div>
);

LoadingMessage.propTypes = propTypes;
LoadingMessage.defaultProps = defaultProps;

export default LoadingMessage;
